import { c as _c } from "react/compiler-runtime";
import { isMobileOnly, isTablet } from 'react-device-detect';
import RMCarousel from 'react-multi-carousel';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';
import CarouselSlide from './CarouselSlide';
const responsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};
const Carousel = t0 => {
    const $ = _c(6);
    const { media, imgAltSuffix, className: t1 } = t0;
    const incomingClassName = t1 === undefined ? "" : t1;
    const deviceType = isMobileOnly ? "mobile" : isTablet ? "tablet" : "desktop";
    const className = `flex flex-col justify-center items-center !bg-transparent !static !h-auto overflow-hidden ${incomingClassName}`;
    let t2;
    if ($[0] !== imgAltSuffix || $[1] !== media) {
        t2 = media && media.length ? <RMCarousel ssr={true} deviceType={deviceType} infinite={media.length > 1} responsive={responsive} containerClass="w-full h-carousel 2xl:h-192" itemClass="flex flex-col flex-shrink-0 h-carousel 2xl:h-192" dotListClass="!static flex-grow flex flex-row justify-center overflow-x-auto w-screen !mt-4 pb-4" customRightArrow={<ArrowRight />} customLeftArrow={<ArrowLeft />} autoPlay={false} shouldResetAutoplay={false}>{media.map((m, index) => <CarouselSlide key={m.id} media={m} index={index} total={media.length} imgAltSuffix={imgAltSuffix}/>)}</RMCarousel> : null;
        $[0] = imgAltSuffix;
        $[1] = media;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    let t3;
    if ($[3] !== className || $[4] !== t2) {
        t3 = <div className={className}>{t2}</div>;
        $[3] = className;
        $[4] = t2;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    return t3;
};
export default Carousel;
